import React from 'react';
import { RadioButtonGroup } from './RadioButtonWithTextStyles';

interface IProps {
  children: React.ReactElement[];
}

export const RadioButtonWithTextGroup: React.FC<IProps> = (props) => {
  const { children } = props;
  return <RadioButtonGroup>{children}</RadioButtonGroup>;
};
